// js
import React from 'react';
import PropTypes from 'prop-types';
import CheckedList from './CheckedList';


const TitledCheckedList = ({ title, items }) => {

  return (
    <div className='titled-checked-list'>
      <h3>{title}</h3>
      <CheckedList items={items} />
    </div>
  );
};

TitledCheckedList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired
};

export default TitledCheckedList;



// WEBPACK FOOTER //
// ./src/components/common/TitledCheckedList.js